import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import '../About.css';

const RealEstate = () => {
  const solutions = ['Property Management Systems', 'CRM for Real Estate', 'Virtual Tour Platforms', 'Listing Management', 'Transaction Management', 'Tenant Portals'];

  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="container">
          <h1>Real Estate Solutions</h1>
          <p>Property management and real estate transaction software</p>
        </div>
      </section>
      <section className="about-story">
        <div className="container">
          <div className="story-content">
            <h2>Streamlining Real Estate</h2>
            <p>We develop comprehensive real estate software that manages properties, streamlines transactions, and enhances client relationships. From listing management to virtual tours, we help real estate professionals work more efficiently.</p>
          </div>
        </div>
      </section>
      <section className="about-expertise">
        <div className="container">
          <div className="section-header"><h2>Real Estate Solutions</h2></div>
          <div className="expertise-grid">{solutions.map((s, i) => <div key={i} className="expertise-item">{s}</div>)}</div>
        </div>
      </section>
      <section className="about-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Modernize Your Real Estate Business</h2>
            <p>Let's discuss your property management software needs.</p>
            <Link to="/contact"><Button variant="contained" size="large" endIcon={<ArrowForwardIcon />} sx={{ backgroundColor: '#2271b1', color: '#ffffff', fontWeight: '600', padding: '14px 32px', fontSize: '15px', textTransform: 'none', borderRadius: '3px', boxShadow: '0 1px 0 #135e96', '&:hover': { backgroundColor: '#135e96' } }}>Contact Us</Button></Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default RealEstate;
